import React from 'react';
import { BasicContainer } from '../../UI/ContentContainer';
import PageTitle from '../../UI/PageTitle';
import TextContent from '../../UI/TextContent';
import { Typography } from '@mui/material';
import SupportContent from '../../UI/SupportContent';
import MetaTags from '../../MetaTags/MetaTags';

const supportData = [
    '월 1회 이상 사업장 안전관리상태 점검 및 법령 위반사항, 불안전한요소에 대한 구체적인 개선대책 제시',
    '산업재해발생의 원인조사 및 재발방지를 위한 기술적 조언·지도',
    '최신 계측장비를 활용한 점검 및 개선대책 제시',
    '안전기술자료 및 교육자료 등 각종 안전관련 자료제공',
    '산업안전보건법, 산업재해보상보험법 및 근로기준법 등 관련법령에 대한 상담'

]

const SmtPage = () => {

    return (
        <BasicContainer>
            <MetaTags
                title="안전관리기술지도"
                description="안전관리기술지도에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-안전관리기술지도"
                ogdescription="안전관리기술지도에 대해 소개 합니다."
            />
            <PageTitle title="안전관리기술지도" />
            <TextContent
                title="안전관리기술지도란?"
            >
                <Typography variant="description" component="p" sx={{lineHeight: "2"}} textAlign="center">법적 안전관리자의 선임 유·무와 관계없이 사업주의 자율의사에 따른 요청에 의하여 전문인력과 최신장비를 활용, 안전에 관한 기술업무를 지원하는 사업</Typography>
            </TextContent>


            <SupportContent 
                title="세부지원내용"
                data={supportData}
                aos="fade-left"
            />
        </BasicContainer>
        
    )
}

export default SmtPage;